/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DoctorSpeciality } from '../models/DoctorSpeciality';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DoctorSpecialitiesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns DoctorSpeciality
     * @throws ApiError
     */
    public doctorSpecialityList(): CancelablePromise<Array<DoctorSpeciality>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/doctor-specialities/',
        });
    }
}
